export default {
  methods: {
    formatarDecimal4(valor) {
      const numero = Number(valor || 0);
      return numero.toFixed(4).replace(".", ",");
    },
    arredondarDecimal(valor, casas = 4) {
      const numero = Number(valor || 0);
      const fator = Math.pow(10, casas);
      return Math.round((numero + Number.EPSILON) * fator) / fator;
    },
    calcularTotalOrcamento(idFornecedor) {
      const total = (this.itensPreenchidos || [])
        .filter((item) => item.idFornecedor === idFornecedor)
        .reduce((soma, item) => soma + (Number(item.total) || 0), 0);

      return this.arredondarDecimal(total);
    },
    normalizarNumeroPayload(valor, casas = 4) {
      if (valor === null || valor === undefined || valor === "") {
        return 0;
      }

      const texto = String(valor).trim();
      const normalizado = texto.includes(",")
        ? texto.replace(/\./g, "").replace(",", ".")
        : texto;
      const numero = Number(normalizado);

      if (!Number.isFinite(numero)) {
        return 0;
      }

      return this.arredondarDecimal(numero, casas);
    },
    converterDecimal(valor) {
      if (!valor) return 0;

      const apenasNumeros = valor.toString().replace(/\D/g, "");

      return this.arredondarDecimal(Number(apenasNumeros) / 10000);
    },
    posicionarCursorFim(event) {
      const input = event?.target;
      if (!input || typeof input.setSelectionRange !== "function") {
        return;
      }

      this.$nextTick(() => {
        const fim = input.value.length;
        input.setSelectionRange(fim, fim);
      });
    },
    atualizarDecimalItem(valor, item, campo, idFornecedor, idSolicitacaoItem) {
      item[campo] = this.converterDecimal(valor);
      this.calcularTotais(idFornecedor, idSolicitacaoItem);
    },
    atualizarDecimalFornecedor(valor, fornecedor, campo) {
      this.$set(fornecedor, campo, this.converterDecimal(valor));
    },
  },
};
